/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-body-font-family',
  templateUrl: './theme-option-tooltips-body-font-family.component.html',
  styleUrls: ['./theme-option-tooltips-body-font-family.component.css']
})
export class ThemeOptionTooltipsBodyFontFamilyComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_bodyFontFamily';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_bodyFontFamily', value);
  }


}
